import { ButtonFilePicker, FilePicker, FilePickerProps, useFilePicker, useFilesPicker } from '..';
import useTempFile, { TempFileValue, useTempFiles } from './useTempFile';

export type TempFilePickerOwnProps = {
    value: TempFileValue | null;
    onChange: (value: TempFileValue) => void;
    isDisabled?: boolean;
    error?: string;
};

export type { TempFileValue };

export type TempFilePickerProps = TempFilePickerOwnProps &
    Pick<FilePickerProps, 'style' | 'title' | 'isDisabled' | 'documentPickerOptions'>;

const TempFilePicker: React.FC<TempFilePickerProps> = ({ value, onChange, ...props }) => {
    // @ts-expect-error TS2322
    const tempFile = useTempFile({ value, onChange });

    return (
        <FilePicker
            {...props}
            value={value ? { name: value.name, originalName: value.originalName } : null}
            onClear={() => {
                // @ts-expect-error TS2345
                onChange(null);
            }}
            isLoadingFile={tempFile.isUploading}
            onPick={tempFile.onFileSelected}
        />
    );
};

export default TempFilePicker;

export type TempButonFilePickerOwnProps = {
    onPick: (value: TempFileValue) => void;
    isDisabled?: boolean;
};

export type TempButonFilePickerProps = TempButonFilePickerOwnProps &
    Pick<FilePickerProps, 'style' | 'title' | 'isDisabled' | 'documentPickerOptions'>;

export const TempButtonFilePicker: React.FC<TempButonFilePickerProps> = (props) => {
    const tempFile = useTempFile({
        value: null,
        onChange: (value) => {
            if (value) {
                props.onPick(value);
            }
        },
    });

    return <ButtonFilePicker {...props} isLoadingFile={tempFile.isUploading} onPick={tempFile.onFileSelected} />;
};

export type UseTempFilePickerArgs = { onPick: (value: TempFileValue) => void; testID?: string };

export type UseTempFilePickerReturnValue = {
    isLoadingFile: boolean;
    onPress: () => void;
    E2EInput: React.ReactElement | null;
};

export const useTempFilePicker = (args: UseTempFilePickerArgs): UseTempFilePickerReturnValue => {
    const tempFile = useTempFile({
        value: null,
        onChange: (value) => {
            if (value) {
                args.onPick(value);
            }
        },
    });

    const { onPress, E2EInput } = useFilePicker({
        onPick: tempFile.onFileSelected,
        isDisabled: false,
        isLoadingFile: tempFile.isUploading,
        testID: args.testID,
    });

    return {
        isLoadingFile: tempFile.isUploading,
        onPress,
        E2EInput,
    };
};

export type UseTempFilesPickerArgs = { onPick: (value: TempFileValue[]) => void };
export const useTempFilesPicker = (args: UseTempFilesPickerArgs): UseTempFilePickerReturnValue => {
    const tempFiles = useTempFiles({
        value: null,
        onChange: (value) => {
            if (value) {
                args.onPick(value);
            }
        },
    });

    const { onPress, E2EInput } = useFilesPicker({
        onPick: tempFiles.onFileSelected,
        isDisabled: false,
        isLoadingFiles: tempFiles.isUploading,
    });

    return {
        isLoadingFile: tempFiles.isUploading,
        onPress,
        E2EInput,
    };
};
